import { render, staticRenderFns } from "./PermissionsForm.vue?vue&type=template&id=02e9c54e&scoped=true"
import script from "./PermissionsForm.vue?vue&type=script&lang=js"
export * from "./PermissionsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e9c54e",
  null
  
)

export default component.exports